import React from 'react'
import Cookies from 'js-cookie'
import { Trans, withTranslation } from 'react-i18next'


// WebAPI移行前のデータは <a href..>無し、
// 移行後のデータは<a href...>ありに変換する
const renderFileLink = (url) => {
  const fileName = decodeURIComponent(url.split('/').pop())
  const isOldS3 = url.startsWith('https://download')

  if (isOldS3) {
    // 旧データ → リンクなし（テキストのみ）
    return <span>{fileName}</span>
  }

  // 新API → 通常リンク
  return (
    <a href={url}>
      {fileName}
    </a>
  )
}

const ResultRow = ({ u, key }) => {

  const err_code = u[1] === 'E_00_00_00' ? '' : '(' + u[1] + ')'
  const err_msg = u[1]
  const lang = Cookies.get('lang') || 'ja'
  const userFirstName = !!u[10] ? u[10] : ''
  const userLastName = !!u[11] ? u[11] : ''
  const updatedUserFullName =
    lang === 'ja'
      ? (`${userLastName} ${userFirstName}`)
      : (`${userFirstName} ${userLastName}`)

    
  // PickingList 複数ファイル対応
  const excelUrls = u[7].split('|')
  const csvUrls = u[8].split('|')

  return (
    <tr key={key}>
      <td>
        { // Date Time
          u[0]
        }
      </td>
      <td style={{width: '150px'}}>{updatedUserFullName}</td>
      <td> 
        {　// Model Filename
          u[5]
        }
      </td>
      <td>
        <Trans i18nKey={err_msg}/>{err_code}</td>
      <td>
        { // Picking List Excel links
          u[7] !== '' ?
          excelUrls.map((url, index) => (
          <div key={index}>
            {renderFileLink(url)}
          </div>
          ))
          : ''
        }
        { // Picking List csv links
          u[8] !== '' ?
          csvUrls.map((url, index) => (
          <div key={index}>
            {renderFileLink(url)}
          </div>
          ))
          : ''
        }
      </td>
      <td>
        { // 作業レポート
          u[9] !== '' ?
            renderFileLink(u[9])
          : ''
        }
      </td>
      <td>
        { // Log
          u[6]!=='' ? 
            renderFileLink(u[6])
          : ''
        }
      </td>
    </tr>
  )
}

export default withTranslation()(ResultRow)
